<template>
  <div
    class="guard-overlay"
    :class="{ 'guard-overlay--hidden': !visible }"
    @click.stop="$emit('dismiss')"
  >
    <header class="guard-overlay__header">
      <div class="guard-overlay__brand">
        fuse<span class="guard-overlay__brand-access">access</span
        ><span class="guard-overlay__brand-dot">·</span>
      </div>
    </header>

    <div class="guard-overlay__video-container">
      <slot name="media">
        <video
          ref="video"
          class="guard-overlay__video"
          :src="videoSrc"
          autoplay
          muted
          playsinline
        ></video>
      </slot>
    </div>

    <footer class="guard-overlay__footer">
      <p class="guard-overlay__tagline">
        Conectamos tecnología, protegemos lo que más importa.
      </p>
      <div class="guard-overlay__action-prompt">
        <svg viewBox="0 0 24 24">
          <path d="M15 15l5 5M4 4l16 16" />
          <circle cx="9" cy="9" r="4" />
        </svg>
        Toca la pantalla para comenzar
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "GuardOverlay",
  data() {
    return {
      videoTimeHandler: null,
    };
  },
  emits: ["dismiss"],
  props: {
    videoSrc: {
      type: String,
      default: "/videoVigilante_org.mp4",
    },
    videoLoopSeconds: {
      type: Number,
      default: 10,
    },
    visible: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    this.initVideoLoop();
  },
  watch: {
    visible(newValue) {
      if (newValue) {
        this.restartVideo();
      }
    },
  },
  methods: {
    initVideoLoop() {
      const video = this.$refs.video;
      if (!video) return;
      this.videoTimeHandler = () => {
        if (video.currentTime >= this.videoLoopSeconds) {
          video.currentTime = 0;
          video.play();
        }
      };
      video.addEventListener("timeupdate", this.videoTimeHandler);
    },
    restartVideo() {
      const video = this.$refs.video;
      if (!video) return;
      video.currentTime = 0;
      video.play();
    },
  },
  beforeDestroy() {
    if (this.videoTimeHandler && this.$refs.video) {
      this.$refs.video.removeEventListener("timeupdate", this.videoTimeHandler);
    }
  },
};
</script>

<style scoped lang="scss">
@import "../styles";

.guard-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: #0d0e11;
  overflow: hidden;
  cursor: pointer;
  user-select: none;
  transition: opacity 0.5s cubic-bezier(0.4, 0, 0.2, 1), visibility 0.5s;

  &--hidden {
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
  }
}

.guard-overlay__video-container {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #111214;
}

.guard-overlay__video {
  width: 100%;
  height: 100%;
  max-width: none !important;
  object-fit: cover;
  display: block;
}

.guard-overlay__header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  padding: 24px 20px 15px;
  background: linear-gradient(
    to bottom,
    rgba(13, 14, 17, 0.95) 0%,
    rgba(13, 14, 17, 0.6) 70%,
    transparent 100%
  ) !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.guard-overlay__brand {
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #ffffff;
  display: flex;
  align-items: center;
}

.guard-overlay__brand-access {
  color: $guard-cyan-500;
  font-weight: 400;
}

.guard-overlay__brand-dot {
  color: $guard-cyan-500;
  font-size: 1.5em;
  line-height: 0;
  margin-left: 0.15em;
}

.guard-overlay__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  padding: 15px 20px 24px;
  background: linear-gradient(
    to top,
    rgba(13, 14, 17, 0.95) 0%,
    rgba(13, 14, 17, 0.6) 70%,
    transparent 100%
  );
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.guard-overlay__tagline {
  margin: 0;
  font-size: 15px;
  font-weight: 400;
  color: #e2e3e8;
  line-height: 1.45;
  max-width: 320px;
  text-align: left;
}

.guard-overlay__action-prompt {
  margin-top: 0;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: rgba($guard-cyan-500, 0.15);
  border: 1px solid rgba($guard-cyan-500, 0.4);
  color: $guard-cyan-100;
  padding: 10px 20px;
  border-radius: 30px;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  animation: guard-overlay-pulse 2s infinite;

  svg {
    width: 16px;
    height: 16px;
    stroke: currentColor;
    fill: none;
    stroke-width: 2;
  }
}

@keyframes guard-overlay-pulse {
  0%,
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba($guard-cyan-500, 0.4);
  }
  50% {
    transform: scale(1.03);
    box-shadow: 0 0 15px 4px rgba($guard-cyan-500, 0.25);
  }
}
</style>
